import { Box, Drawer, styled } from '@mui/material'

export const StyledBox = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
`

export const StyledDrawer = styled(Drawer)`
  & .MuiDrawer-paper {
    background: ${({ theme }) => theme.palette.custom.white};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  }
`
